import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestDeleteStaffManager } from "./deleteStaffManager.request";
import { DeleteStaffManagerResponse } from "./deleteStaffManager.types";

const useDeleteStaffManager = (
  options?: MutationOptions<
    DeleteStaffManagerResponse,
    ApiServiceError<ApiError>
  >
) => {
  const refetchStaffManagers = useRefetchQuery(["staff"]);

  return useMutation({
    mutationFn: requestDeleteStaffManager,
    ...options,
    onSuccess: (...args) => {
      refetchStaffManagers();
      options?.onSuccess?.(...args);
    }
  });
};

export default useDeleteStaffManager;
